import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, cloneElement } from 'react';
import { ClickAwayListener } from '../click-away-listener';
import { Fade } from '../fade';
import { Popper } from '../popper';
export const ClickAwayFadePopper = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const onClickAway = () => {
        setAnchorEl(null);
    };
    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const renderChildren = (children) => cloneElement(children, { onClick: handleClick });
    const open = Boolean(anchorEl);
    const id = open ? 'click-away-fade-popper' : undefined;
    let popperComponent;
    if (!props.fade) {
        popperComponent = (_jsx(Popper, Object.assign({ id: id, open: open, anchorEl: anchorEl }, props.popper, { children: props.popperBody })));
    }
    else {
        popperComponent = (_jsx(Popper, Object.assign({ id: id, open: open, anchorEl: anchorEl, transition: true }, props.popper, { children: ({ TransitionProps }) => (_jsx(Fade, Object.assign({}, TransitionProps, props.fade, { children: props.popperBody }))) })));
    }
    let renderedChildren = _jsx("div", { onClick: handleClick });
    if (props.titleElement) {
        renderedChildren = renderChildren(props.titleElement);
    }
    return (_jsx(ClickAwayListener, Object.assign({ onClickAway: onClickAway }, props.clickAway, { children: _jsxs(_Fragment, { children: [renderedChildren, popperComponent] }) })));
};
